import type { ReactNode } from "react";

/**
 * Casilla del sistema (`sk-check`: nativo oculto, `sk-box` lo pinta), con la
 * variante nueva de biblioteca.html: **cerrada con porqué**. Una casilla
 * `closed` lleva `aria-disabled` (no `disabled`): sigue alcanzable a foco y
 * al lector, se apaga solo la caja y su porqué (`help`) queda enlazado con
 * `aria-describedby`; el clic no la cambia y llama a `onClosed` para que la
 * pantalla lo diga en voz alta (un toast).
 */
export function Check({ id, label, help, checked, onChange, closed, onClosed }: {
  id: string;
  label: ReactNode;
  help?: ReactNode | undefined;
  checked: boolean;
  onChange: (checked: boolean) => void;
  closed?: boolean | undefined;
  onClosed?: (() => void) | undefined;
}) {
  return (
    <label className="sk-check">
      <input
        type="checkbox" id={id} value={id} checked={checked}
        aria-labelledby={`${id}-l`} aria-describedby={help !== undefined ? `${id}-h` : undefined}
        aria-disabled={closed === true ? true : undefined}
        onClick={(e) => { if (closed === true) { e.preventDefault(); onClosed?.(); } }}
        onChange={(e) => { if (closed !== true) onChange(e.target.checked); }}
      />
      <span className="sk-box" />
      <span>
        <span id={`${id}-l`}>{label}</span>
        {help !== undefined && <span className="sk-help" id={`${id}-h`}>{help}</span>}
      </span>
    </label>
  );
}
